import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { CtaButtonComponent } from '../../cta-button/cta-button.component';

@Component({
  selector: 'wil-registration-complete-dialog',
  standalone: true,
  imports: [MatDialogModule, CtaButtonComponent],
  templateUrl: './registration-complete-dialog.component.html',
  styleUrl: './registration-complete-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationCompleteDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<RegistrationCompleteDialogComponent>);

  public close(): void {
    this.dialogRef.close();
  }
}
